import {
  Box,
  Image,
  Center,
  Text,
  Stack,
  HStack,
  Spacer,
  useBreakpointValue,
  Modal,
  useDisclosure,
} from "@chakra-ui/react";
import { Header } from "../components/Header";
import { MainPageContentBlock } from "../components/MainPageContentBlock";
import { ProjectPlaner } from "../components/ProjectPlaner";
import maurer from "../components/images/maurer.jpg";
import stahl from "../components/images/stahl.jpeg";
import fliesen from "../components/images/fliesen.jpeg";
import { Logos } from "../components/Logos";
import logo from "../components/images/logo/logo.png";
import { useNavigate } from "react-router-dom";
import aufbau from "../components/images/aufbau.jpg";

export const MotivationText = (props) => {
  const { content, ...rest } = props;
  return (
    <Text
      py={[5, 7, 10, 10]}
      fontSize={[16, 20, 23, 23]}
      textAlign={"center"}
      fontWeight={"extrabold"}
      letterSpacing={1.2}
      {...rest}
    >
      {content}
    </Text>
  );
};

export function Main() {
  const variant = useBreakpointValue({ base: "base", sm: "sm", md: "md" });
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box>
        <Center w="100%" h="100vh">
          <Image src={aufbau} w="50%" />
        </Center>
        {/* <Header />
        <Stack>
          <MotivationText
            content={
              "Unsere Leistungen beginnen mit einer Fachkompetenten Beratung, über die Planung bis hin zur Ausführung"
            }
          />
          <Stack spacing={[5, 5, 20, 20]}>
            <MainPageContentBlock
              size={100}
              title={"MAURERARBEITEN"}
              link={"/maurerarbeiten"}
              image={maurer}
            />
            <MainPageContentBlock
              size={1000}
              title={"FLIESENARBEITEN"}
              link={"/fliesenarbeiten"}
              image={fliesen}
              side={"right"}
            />
            <MainPageContentBlock
              size={1000}
              title={
                variant !== "base"
                  ? "STAHL-BETONBAUARBEITEN"
                  : "STAHL- BETONBAU"
              }
              link={"/stahl-betonbau"}
              image={stahl}
            />
          </Stack>
          <ProjectPlaner start={0} pt={5} />
          <MotivationText
            content="Wir arbeiten ausschließlich mit qualitativ hochwertigen Materialien, von
      Baustoffhändlern aus der Region."
          />
          <Logos pb={10} />
          {variant === "md" && (
            <Center cursor={"pointer"} onClick={() => window.scrollTo(0, 0)}>
              <Image w={"50vw"} src={logo} />
            </Center>
          )}
          <HStack px={5}>
            <Spacer />
            <Text
              color="gray.600"
              as="u"
              cursor={"pointer"}
              onClick={() => navigate("/datenschutz")}
            >
              {" "}
              Datenschutzerklärung{" "}
            </Text>
          </HStack>
        </Stack> */}
      </Box>
    </>
  );
}
